import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';
import type { ImageMediaItem } from 'components/GalleryMediaPreviewer/shared/types';
import Image from 'components/generic/Image';
import { useIsChanel } from 'hooks/user/useIsBrand';
import { MediaCarouselItem } from '../../GalleryThumbnailCarousel';

const ThumbnailImage = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export default function ThumbnailGalleryImageItem({
    imageItem: { thumbnail, alt },
    isActive,
    ...restProps
}: { imageItem: ImageMediaItem; isActive: boolean } & ComponentPropsWithoutRef<'button'>) {
    const isChanel = useIsChanel();

    return (
        <MediaCarouselItem $isChanel={isChanel} $isActive={isActive} {...restProps}>
            <ThumbnailImage
                src={thumbnail}
                sizes={118}
                transformType="ThumbnailScale"
                imageType="product"
                loading="lazy"
                alt={alt || ''}
            />
        </MediaCarouselItem>
    );
}
